
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qr/menu",
      function () {
        return require("private-next-pages/qr/menu/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qr/menu"])
      });
    }
  